import initialState from './initialState';

import {
  RECEIVE_LATEST_APPROVALS,
  HANDLE_LATEST_APPROVALS_ERROR
} from '../actions/actionTypes';

export function latestApprovals(state = initialState.latestApprovals, action) {
  switch (action.type) {
    case RECEIVE_LATEST_APPROVALS:
      return action.latestApprovals;
    default:
      return state;
  }
}

export function latestApprovalsError(state = initialState.latestApprovalsError, action) {
  switch (action.type) {
    case HANDLE_LATEST_APPROVALS_ERROR:
      return action.latestApprovalsError;
    default:
      return state;
  }
}
